module.exports = __webpack_public_path__ + "static/media/sexy.c44fb005.png";